import { DefaultProjectorFn, MemoizedSelector, createSelector } from '@ngrx/store';

import { FeatureDeprecated } from '@vi-iot/client';

import { AppState } from '../app.state';

import { OperatingModesState } from './operating-modes.state';

export namespace OperatingModesSelectors {
  export const operatingModes = (state: AppState): OperatingModesState => state.operatingModes;

  export function getOperatingModes<T, K>(
    gatewaySerial: string
  ): MemoizedSelector<
    AppState,
    {
      circuits: string[];
      mode: { [key: string]: FeatureDeprecated<T, K> };
      isDhw: boolean;
    },
    DefaultProjectorFn<{
      circuits: string[];
      mode: { [key: string]: FeatureDeprecated<T, K> };
      isDhw: boolean;
    }>
  > {
    return createSelector(
      operatingModes,
      (state: OperatingModesState) =>
        state.installation[gatewaySerial] as {
          circuits: string[];
          mode: { [key: string]: FeatureDeprecated<T, K> };
          isDhw: boolean;
        }
    );
  }
}
